export const dimensions = {
    "LENGTH": "По ширине",
    "WIDTH": "По высоте"
}